module.exports = __webpack_public_path__ + "img/Guinea-Bissau.3d40dafc.png";